import xss from 'xss'
export default Vue => {
  var _error = Vue.prototype.$Message.error
  var _success = Vue.prototype.$Message.success
  var _warning = Vue.prototype.$Message.warning
  var _loading = Vue.prototype.$Message.loading
  Vue.prototype.$Message.error = (options) => {
    // options.content = xssFilter(options.content)
    if(typeof options === 'string') {
      options = xssFilter(options)
    } 
    if(typeof options === 'object'&&options.content) {
      options.content = xssFilter(options.content)
    }
    _error.call(Vue.prototype.$Message,options)
  }
  Vue.prototype.$Message.success = (options) => {
    // options.content = xssFilter(options.content)
    if(typeof options === 'string') {
      options = xssFilter(options)
    } 
    if(typeof options === 'object'&&options.content) {
      options.content = xssFilter(options.content)
    }
    _success.call(Vue.prototype.$Message,options)
  }
  Vue.prototype.$Message.warning = (options) => {
    // options.content = xssFilter(options.content)
    if(typeof options === 'string') {
      options = xssFilter(options)
    } 
    if(typeof options === 'object'&&options.content) {
      options.content = xssFilter(options.content)
    }
    _warning.call(Vue.prototype.$Message,options)
  }
  Vue.prototype.$Message.loading = (options) => {
    // options.content = xssFilter(options.content)
    if(typeof options === 'string') {
      options = xssFilter(options)
    } 
    if(typeof options === 'object'&&options.content) {
      options.content = xssFilter(options.content)
    }
    _loading.call(Vue.prototype.$Message,options)
  }
}

function xssFilter(str){
  // var str1 = str
  // if (new RegExp(".*?script[^>]*?.*?(<\/.*?script.*?>)*", "ig").test(str)) {//包含
  //   str1 = str1.replace('script', '</*script*/>');//替换的内容
  // }
  // if(new RegExp(".*?iframe[^>]*?.*?(<\/.*?iframe.*?>)*", "ig").test(str)){
  //   str1 = str1.replace('iframe', '</*iframe*/>');//替换的内容
  // }
  // if(new RegExp(".*?img[^>]*?.*?(<\/.*?img.*?>)*", "ig").test(str)){
  //   str1 = str1.replace('img', '</*img*/>');//替换的内容
  // }
  // if(new RegExp("(<a)(</a)", "ig").test(str)){
  //   str1 = str1.replace('a', '<*a*/>');//替换的内容
  // }
  var options = {
    // 默认白名单参考 xss.whiteList
    whiteList: {
      // a: ['href', 'style'],
      // img: ['src', 'alt'],
    },
    stripIgnoreTag: true, // 去掉不在白名单上的标签   true：去掉不在白名单上的标签
    stripIgnoreTagBody: ['script', 'style','a','iframe','img'], // 去掉不在白名单上的标签及标签体
    // ['tag1', 'tag2']：仅去掉指定的不在白名单上的标签
    onTagAttr: function () {
      // todo
    },
  }
  return xss(str,options)
}